'use client';

import { c as _c } from "react/compiler-runtime";
import { SidebarContent } from '@/components/layout/sidebar-content';
import { cn } from '@/lib/ui/utils';
import { useLayoutStore } from '@/stores/layout';
export function AppSidebar() {
  const $ = _c(10);
  const sidebarOpen = useLayoutStore(_temp);
  const t0 = sidebarOpen ? "md:w-70" : "w-0 overflow-hidden";
  let t1;
  if ($[0] !== t0) {
    t1 = cn("shrink-0 transition-[width] duration-normal ease-position motion-reduce:transition-none", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = sidebarOpen ? "md:flex md:flex-col" : "hidden!";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("z-sidebar hidden w-70 shrink-0 sticky top-14 h-[calc(100dvh-3.5rem)] overflow-y-auto border-l border-border-primary bg-background-secondary p-4", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SidebarContent />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <aside className={t3}>{t4}</aside>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t5) {
    t6 = <div className={t1}>{t5}</div>;
    $[7] = t1;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(state) {
  return state.sidebarOpen;
}